<template>
  <!-- 该轮播图样式为 左右轮播图 eg: https://www.fjdynamics.com/product/lawnmower.html 最后第二屏轮播样式 -->

  <section class="left-right-swiper">
    <h2 class="ta-c">{{ title }}</h2>
    <div class="sub-title ta-c" v-if="subTitle">{{ subTitle }}</div>

    <!-- 轮播效果样式2:start -->
    <div class="swiper-style2">
      <div class="swiper-wrapper">
        <client-only>
          <swiper class="" :options="swiperOption" ref="swiper">
            <swiper-slide v-for="(item, index) in swiperData" :key="index">
              <div class="img-wrapper">
                <!-- 轮播图设置 loop 首尾俩个图片无法懒加载 所以采取中间图片懒加载 -->
                <img
                  :src="item.imgSrc"
                  width="100%"
                  height="100%"
                  v-if="index == 0 || index == swiperData.length - 1"
                  :alt="item.desc"
                />
                <img v-lazy="item.imgSrc" v-else :alt="item.desc" width="100%" height="100%" />
                <!-- <img width="100%" :src="item.imgSrc" height="100%" :alt="item.desc" /> -->
                <!-- <img width="100%" v-lazy="item.imgSrc" height="100%" :alt="item.desc" /> -->
                <div class="pa img-bottom-desc" :style="descStyle">
                  {{ item.desc }}
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </client-only>
      </div>

      <div class="swiper-pagination-wrapper"></div>
      <div class="swiper-button-wrapper in-pc">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <!-- 轮播效果样式2:end -->
  </section>
</template>

<script>
  export default {
    name: 'LeftRightCarousel',
    props: {
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      },
      swiperOption: {
        type: Object,
        default: () => {}
      },
      // 描述自定义样式
      descStyle: {
        type: Object,
        default: () => {}
      },
      swiperData: {
        type: Array,
        default: () => []
      },
      activeIndex: {
        type: [Number, String],
        default: -1
      }
    },
    data() {
      return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
      showDesc(idx) {
        return this.activeIndex === idx || (this.activeIndex === 0 && !idx)
      }
      // swiperNext() {
      //   this.$refs.swiper.$swiper.slideNext()
      // },
      // swiperPrev() {
      //   this.$refs.swiper.$swiper.slidePrev()
      // }
    }
  }
</script>

<style scoped lang="scss">
  /* 带左右控制箭头滑动轮播样式 */
  .swiper-style2 {
    position: relative;
    overflow: hidden;
  }

  .left-right-swiper h2 {
    margin-bottom: 0.24rem;
    font-size: 0.48rem;
  }
  .swiper-style2 .swiper-slide .img-wrapper {
    position: relative;
  }
  .swiper-slide .img-wrapper .img-bottom-desc {
    position: absolute;
    width: 100%;
    bottom: 0.2rem;
    left: 0;
    // transition: opacity 0.3s linear;
    text-align: center;
    font-size: 0.32rem;
    font-weight: 500;
    color: #fff;
    opacity: 0;
  }
  .swiper-slide-active .img-wrapper .img-bottom-desc {
    opacity: 1;
  }

  :deep(.swiper-style2 .swiper-slide .img-wrapper:after) {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  :deep(.swiper-style2 .swiper-slide-active .img-wrapper:after) {
    background-color: rgba(0, 0, 0, 0);
  }
  :deep(.swiper-style2 .swiper-pagination-wrapper) {
    text-align: center;
    margin-top: 0.32rem;
    font-size: 0;
    bottom: 0;
  }
  :deep(.swiper-style2 .swiper-pagination-wrapper span) {
    width: 0.34rem;
    height: 0.03rem;
    border-radius: 4px;
    margin: 0 0.04rem !important;
    opacity: 1;
    background-color: #ccc;
  }
  :deep(.swiper-style2 .swiper-pagination-fraction) {
    position: absolute;
    bottom: 0.16rem;
    color: #fff;
    z-index: 3;
    font-size: 0.2rem;
  }
  :deep(.swiper-style2 .swiper-pagination-fraction span) {
    background-color: transparent;
    width: auto;
    height: auto;
    font-weight: 400;
  }
  :deep(.swiper-style2 .swiper-pagination-wrapper span.swiper-pagination-bullet-active) {
    background-color: #999;
  }
  :deep(.swiper-style2 .swiper-button-wrapper) {
    position: absolute;
    width: 60%;
    z-index: 3;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  :deep(.swiper-style2 .swiper-button-prev) {
    opacity: 0.75;
    width: 0.48rem;
    height: 0.48rem;
    transition: opacity 0.1s linear;
    background: url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-linejoin='round' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath d='M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z'/%3E%3Cpath stroke-linecap='round' d='M27 33l-9-9 9-9'/%3E%3C/g%3E%3C/svg%3E")
      center / cover;
  }
  :deep(.swiper-style2 .swiper-button-next) {
    transform: rotate(180deg);
    opacity: 0.75;
    width: 0.48rem;
    height: 0.48rem;
    transition: opacity 0.1s linear;
    background: url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-linejoin='round' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath d='M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z'/%3E%3Cpath stroke-linecap='round' d='M27 33l-9-9 9-9'/%3E%3C/g%3E%3C/svg%3E")
      center / cover;
  }
  :deep(.swiper-style2 .swiper-button-prev:hover, .swiper-style2 .swiper-button-next:hover) {
    opacity: 1;
  }
  :deep(.swiper-style2 .swiper-text-wrapper) {
    position: absolute;
    width: 100%;
    bottom: 0.64rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
  }
  :deep(.swiper-style2 .swiper-text-wrapper > div) {
    opacity: 0;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    transition: opacity 0.3s linear;
    text-align: center;
    font-size: 0.32rem;
    font-weight: 500;
    color: #fff;
  }
  .sub-title {
    padding: 0 0.32rem 0.24rem 0.32rem;
    font-size: 0.18rem;
    color: #666;
  }
</style>
